import React from 'react';
import PropTypes from 'prop-types';
import StyledSeperator from '../styles/LineSeperator.styles';

const LineSeperator = (props) => {
  const { height, color } = props;
  return <StyledSeperator height={height} color={color} />;
};

LineSeperator.propTypes = {
  height: PropTypes.string,
  color: PropTypes.string,
};

LineSeperator.defaultProps = {
  height: '1px',
  color: '#9B9B9B',
};

export default LineSeperator;
